(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-community-spaces"] && !Shopify.designMode) return;
  try {
    
class BvSpaces extends HTMLElement {
	connectedCallback() {
		this.track = this.querySelector(".bv-spaces__track")
		this.prev = this.querySelector(".bv-spaces__nav--prev")
		this.next = this.querySelector(".bv-spaces__nav--next")
		if (!this.track || !this.prev || !this.next) return

		this.prev.addEventListener("click", () => this.scrollByCard(-1))
		this.next.addEventListener("click", () => this.scrollByCard(1))
		this.track.addEventListener("scroll", () => this.sync(), { passive: true })
		this.observer = new ResizeObserver(() => this.sync())
		this.observer.observe(this.track)
		this.sync()
	}

	disconnectedCallback() {
		if (this.observer) this.observer.disconnect()
	}

	scrollByCard(direction) {
		let card = this.track.querySelector(".bv-spaces__item")
		if (!card) return
		let gap = parseFloat(getComputedStyle(this.track).columnGap) || 0
		this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: "smooth" })
	}

	sync() {
		let overflow = this.track.scrollWidth - this.track.clientWidth
		this.classList.toggle("bv-spaces--static", overflow < 2)
		this.prev.disabled = this.track.scrollLeft < 2
		this.next.disabled = this.track.scrollLeft > overflow - 2
	}
}

if (!customElements.get("bv-spaces")) customElements.define("bv-spaces", BvSpaces)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-community-wall"] && !Shopify.designMode) return;
  try {
    
class BvWallMedia extends HTMLElement {
	connectedCallback() {
		if (matchMedia("(prefers-reduced-motion: reduce)").matches) return
		this.video = this.querySelector("video")
		if (!this.video) return

		this.watcher = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.video.muted = true
					this.video.play().catch(() => {})
				} else {
					this.video.pause()
				}
			})
		}, { rootMargin: "0px 0px 10% 0px" })
		this.watcher.observe(this)
	}

	disconnectedCallback() {
		if (this.watcher) this.watcher.disconnect()
	}
}

if (!customElements.get("bv-wall-media")) customElements.define("bv-wall-media", BvWallMedia)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-header"]) return;
  try {
    
class BvHeader extends HTMLElement {
	connectedCallback() {
		this.toggle = this.querySelector(".bv-header__toggle")
		this.drawer = this.querySelector(".bv-header__drawer")
		this.searchToggle = this.querySelector(".bv-header__search-toggle")
		this.searchPanel = this.querySelector(".bv-header__search-panel")
		this.searchInput = this.querySelector(".bv-header__search-input")

		if (this.toggle && this.drawer) {
			this.toggle.addEventListener("click", () => this.switch())
		}
		if (this.searchToggle && this.searchPanel) {
			this.searchToggle.addEventListener("click", () => this.switchSearch())
			document.addEventListener("click", e => {
				if (this.searchOpen() && !this.contains(e.target)) this.switchSearch(false)
			})
		}
		document.addEventListener("keydown", e => {
			if (e.key !== "Escape") return
			if (this.searchOpen()) {
				this.switchSearch(false)
				this.searchToggle.focus()
			}
			if (this.drawer && !this.drawer.hidden) this.switch(false)
		})
		this.cedeToBar()
	}

	searchOpen() {
		return Boolean(this.searchPanel?.hasAttribute("data-open"))
	}

	switchSearch(force) {
		let open = force ?? !this.searchOpen()
		this.searchPanel.toggleAttribute("data-open", open)
		this.searchPanel.inert = !open
		this.searchToggle.setAttribute("aria-expanded", String(open))
		if (open) {
			if (this.drawer && !this.drawer.hidden) this.switch(false)
			this.searchInput?.focus({ preventScroll: true })
		}
		this.refresh?.()
	}

	cedeToBar() {
		if (!document.querySelector("[data-bv-sticky-bar]")) return

		let root = document.documentElement
		let held = false
		let pending = false

		let apply = () => {
			pending = false
			let open = (this.drawer && !this.drawer.hidden) || this.searchOpen()
			root.classList.toggle("bv-nav-yielded", !held && !open && window.scrollY > this.offsetHeight)
		}

		let schedule = () => {
			if (pending) return
			pending = true
			requestAnimationFrame(apply)
		}

		this.refresh = schedule
		addEventListener("scroll", schedule, { passive: true })
		addEventListener("resize", schedule, { passive: true })
		this.addEventListener("focusin", () => {
			held = true
			apply()
		})
		this.addEventListener("focusout", e => {
			if (this.contains(e.relatedTarget)) return
			held = false
			apply()
		})
		apply()
	}

	switch(force) {
		let open = force ?? this.drawer.hidden
		if (open && this.searchOpen()) this.switchSearch(false)
		this.drawer.hidden = !open
		this.toggle.setAttribute("aria-expanded", String(open))
		this.refresh?.()
	}
}

customElements.define("bv-header", BvHeader)

  } catch(e) { console.error(e); }
})();
})();
